import React, { useRef, useEffect } from "react";
import { Sunburst } from "@ant-design/plots";

const SunburstChart = ({ jobCount }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      .sunburstChart .g2-tooltip {
        left: auto !important;
        right: 0px !important;
        transform: none !important;
      }
      .sunburstChart canvas {
        display: block;
      }
      .sunburstChart {
        width: 100% !important;
        height: 100% !important;
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  const config = {
    autoFit: true,
    padding: 0,
    appendPadding: 0,
    data: {
      value: {
        name: "Jobs",
        children: [
          {
            name: "Total Active Jobs",
            value: jobCount?.activeJobs?.totalActiveJobs,
            children: [
              {
                name: "Existing Jobs",
                value: jobCount?.activeJobs?.existingJobs,
              },
              {
                name: "New Jobs",
                value: jobCount?.activeJobs?.newJobs,
              },
            ],
          },
          {
            name: "Total Inactive jobs",
            value: jobCount?.inactiveJobs?.totalInactiveJobs,
            children: [
              {
                name: "Closed Jobs",
                value: jobCount?.inactiveJobs?.closedJobs,
              },
              {
                name: "Cancelled Jobs",
                value: jobCount?.inactiveJobs?.cancelledJobs,
              },
              // ✅ Full Jobs add kiya
              {
                name: "Full Jobs",
                value: jobCount?.inactiveJobs?.fullJobs || 0,
              },
              // ✅ On-Hold Jobs add kiya
              {
                name: "On-Hold Jobs",
                value: jobCount?.inactiveJobs?.onHoldJobs || 0,
              },
            ],
          },
        ],
      },
    },
    animate: {
      enter: { type: "waveIn" },
    },
    innerRadius: 0.5,
    style: {
      fill: (v) => {
        if (v.path === "Total Active Jobs") return "#27BB2E";
        if (v.path === "Total Inactive jobs") return "#006CB7";
        if (v.path === "Total Active Jobs / Existing Jobs")
          return "rgba(39, 187, 46, 0.40)";
        if (v.path === "Total Active Jobs / New Jobs") return "#4AEC52";
        if (v.path === "Total Inactive jobs / Closed Jobs")
          return "rgba(0, 108, 183, 0.40)";
        if (v.path === "Total Inactive jobs / Cancelled Jobs") return "#3F95EA";
        // ✅ Full Jobs color — legend ke saath match (#247bd2)
        if (v.path === "Total Inactive jobs / Full Jobs") return "#247bd2";
        // ✅ On-Hold Jobs color — legend ke saath match (#5d95be)
        if (v.path === "Total Inactive jobs / On-Hold Jobs") return "#5d95be";
      },
    },
    state: {
      active: { zIndex: 2, stroke: "#fff" },
      inactive: { zIndex: 1, stroke: "#fff" },
    },
    interaction: {
      tooltip: {
        render: (e, { title, items }) => {
          const tooltipArr = title.split("/");
          if (tooltipArr.length <= 1) {
            return (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "10px",
                }}
              >
                <div style={{ fontWeight: "700" }}>{title}</div>
                <div style={{ fontWeight: "700" }}>{items[0].value}</div>
              </div>
            );
          }
          return (
            <div>
              <div style={{ fontWeight: "700" }}>{tooltipArr[0]}</div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "10px",
                }}
              >
                <div>{tooltipArr[1]}</div>
                <div>{items[0].value}</div>
              </div>
            </div>
          );
        },
      },
      drillDown: {
        breadCrumb: {
          rootText: "Total Jobs",
          active: { fill: "#1976d2" },
        },
        fixedColor: false,
      },
    },
  };

  return (
    <div
      ref={containerRef}
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
      }}
    >
      <div style={{ width: "100%", height: "100%" }}>
        <Sunburst className="sunburstChart" {...config} />
      </div>
    </div>
  );
};

export default SunburstChart;
